import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/embed/jadwal-buka-puasa/$kota")({
  component: () => <Outlet />,
});